const STEP = {
    HOW_IT_WORKS: 'howItWorks',
    PRICE_YOUR_RENTAL: 'priceYourRental',
    SECURITY_DEPOSIT: 'securityDeposit',
    APPLICATIONS: 'applications',
    CONFIRMATION: 'confirmation',
    JOURNEY_MAP_AFTER_LISTING: 'journeyMapAfterListing',
};

const PROGRESS_STEP = {
    PRICE_YOUR_RENTAL: 'priceYourRental',
    SECURITY_DEPOSIT: 'securityDeposit',
    APPLICATIONS: 'applications',
    CONFIRMATION: 'confirmation',
};

const PROGRESS_STEP_CONFIG = [
    {
        key: PROGRESS_STEP.PRICE_YOUR_RENTAL,
        label: '',
    },
    {
        key: PROGRESS_STEP.SECURITY_DEPOSIT,
        label: '',
    },
    {
        key: PROGRESS_STEP.APPLICATIONS,
        label: '',
    },
    {
        key: PROGRESS_STEP.CONFIRMATION,
        label: '',
    },
];

const DEEP_LINK_STEP = {
    [PROGRESS_STEP.PRICE_YOUR_RENTAL]: STEP.PRICE_YOUR_RENTAL,
    [STEP.SECURITY_DEPOSIT]: STEP.SECURITY_DEPOSIT,
    [PROGRESS_STEP.APPLICATIONS]: STEP.APPLICATIONS,
    [PROGRESS_STEP.CONFIRMATION]: STEP.CONFIRMATION,
};

export {
    PROGRESS_STEP_CONFIG,
    DEEP_LINK_STEP,
    PROGRESS_STEP,
    STEP,
};
